import { formatPrice } from 'utils/general'

/**
 * @info
 *
 * *The "store/cart" directory*
 * This "store" directory declares each of the Vuex
 * modules that all together power the site. Here, we have the
 * Vuex store module that sits behind cart functionality.
 *
 * *This file*
 * This file outlines "getters". Getters are methods
 * that perform modifications to the state value prior
 * to returning the value to the consuming component.
 */

export default {
  subtotal (rootState) {
    return formatPrice(rootState.global.cart.total_price)
  },

  gwpRemovedByUser (state) {
    return state.gwp.removedByUser
  },

  gwpIsActive (state) {
    return state.gwp.status
  },

  gwpProductsTagged (state) {
    return state.gwp.gwpProductsTagged
  },

  recievedGwpVariantsFromCart (state, getters, rootstate) {
    const firstProductInCart = rootstate.global.cart.items[0] || []
    return Object.keys(firstProductInCart.properties)
      .reduce((ids, key) => {
        if (key.includes('_gwp_')) {
          const identifiers = firstProductInCart.properties[key][0].split('_')
          ids.push({
            productId: parseInt(identifiers[0]),
            variantId: parseInt(identifiers[1])
          })
        }
        return ids
      }, [])
  }
}
